import { useState, useEffect, useRef } from 'react';
import '../../../App.css';
import '../../../Tabs.css';
import 'rsuite/DatePicker/styles/index.css';
import { request } from '../../../utils/ApiUtils';
import { showNotification } from '../../../utils/NotificationUtils';
import Table from '../../Table';
import { formatToBRL } from '../../../utils/MonetaryUtils';
import SaveIcon from '@mui/icons-material/CheckCircle';
import { hasAnyRole } from '../../../utils/TokenUtils';
import { rolesMapping } from '../../../utils/RolesUtils';

function DespesaParcelaTab(props) {
    const [dataArray, setDataArray] = useState([]);
    const [pageData, setPageData] = useState([]);
    const [carregando, setCarregando] = useState(true);
    const [erro, setErro] = useState(null);
    const [totals, setTotals] = useState({})

    const carregarDados = async (page = 0, isRefresh) => {
        if (props.despesaId)
            request(`despesa-parcela/${props.despesaId}/paginated?page=${page}&size=${100}`, {
                type: 'POST',
                body: JSON.stringify({}),
                callback: (data) => (
                    setPageData(data),
                    setDataArray(data.content),
                    findTotals()
                ),
                callbackError: (message) => setErro(message || 'Ocorreu um erro inesperado, tente novamente ou contate o suporte.'),
                finally: () => setCarregando(false)
            })
    };

    const findTotals = async (isRefresh) => {

        request(`despesa-parcela/${props.despesaId}/totals`, {
            type: 'GET',
            callback: (data) => (
                setTotals(data)
            ),
            callbackError: (message) => setErro(message || 'Ocorreu um erro inesperado, tente novamente ou contate o suporte.')

        })
    };


    useEffect(() => {
        carregarDados(0, true);
    }, [props.despesaId, props.refreshKey]);

    const atualizarParcela = async (parcela) => {
        request(`despesa-parcela/${parcela.id}`, {
            type: 'PUT',
            body: JSON.stringify(parcela),
            callback: (data) => {
                showNotification('Parcela atualizada', 'success');
                props.loadDespesa && props.loadDespesa();
                parcela.alterada = false;
                updateRowOnDataArray(parcela);
            },
            callbackError: (responseData, message) => {
                const errorsEmpty = !responseData?.errors || Object.keys(responseData?.errors).length === 0;

                if (responseData?.handledError) {
                    if (!errorsEmpty) {
                        Object.entries(responseData?.errors).forEach(([key, value]) => {

                            showNotification(value, 'error', 5000);
                        });
                    } else

                        if (responseData?.error) {
                            showNotification(responseData.error, 'error', 5000);
                        }
                } else {
                    showNotification('Não foi possível atualizar a parcela, revise os dados informados.', 'error');
                }
            }
        })
    }

    const footerTotals = () => (
        <div className="table-footer-totals">
            <h4><span className="table-footer-indicator table-footer-indicator-received" />{`Valor total pago: ${formatToBRL(totals?.totalPago)}`}</h4>
            <h4><span className="table-footer-indicator table-footer-indicator-pending" />{`Valor faltante a pagar: ${formatToBRL(totals?.totalAPagar)}`}</h4>
        </div>
    )

    const onChangeParcela = (parcela, value, field) => {
        const updatedItem = { ...parcela, alterada: true };
        updatedItem[field] = value;

        updateRowOnDataArray(updatedItem)
    }

    const updateRowOnDataArray = (parcela) => {
        const updatedArray = dataArray.map((row) =>
            row.numero === parcela?.numero ? parcela : row
        );

        setDataArray(updatedArray);
    }

    const tableParams = {
        query: (page) => carregarDados(page),
        hasFooter: true,
        columns: [
            {
                label: "Nº Parcela",
                width: "15%",
                type: "input",
                disable: true,
                key: "numero"
            },
            {
                label: "Valor Parcela",
                width: "30%",
                widthValue: '45%',
                disabled: (parcela) => props?.despesaCancelada || parcela?.status?.statusFinalOk || !hasAnyRole(rolesMapping.admin),
                type: "input-decimal",
                onChange: (parcela, value) => onChangeParcela(parcela, value, 'valor'),
                css: "decimal",
                key: "valor"
            },
            {
                label: "Data Vencimento",
                width: "30%",
                widthValue: '45%',
                type: "date",
                disabled: (parcela) => props?.despesaCancelada || parcela?.status?.statusFinalOk || !hasAnyRole(rolesMapping.admin),
                onChange: (parcela, value) => onChangeParcela(parcela, value, 'dataVencimento'),
                key: "dataVencimento"
            },
            {
                label: "Status",
                width: "20%",
                type: "autocomplete",
                component: {
                    endpoint: "status/status",
                    parameters: {
                        disabled: props?.despesaCancelada,
                        disableClearable: true,
                        width: '100%',
                        bodyToSearch: { statusParcela: true },
                        getLabel: (parcela) => parcela.status || '',
                        onChange: (parcela, statusSelecionado) => onChangeParcela(parcela, statusSelecionado?.item, 'status'),
                        getValue: (parcela) => parcela.status,
                        inputStyle: (status) => (
                            {
                                color: 'black',
                                // fontWeight: 'bold',
                                backgroundImage: `radial-gradient(circle, ${status?.item?.color || 'black'} 45%, transparent 50%)`,
                                backgroundPosition: '8px center',
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: '14px 14px',
                                paddingLeft: '28px'
                            }
                        ),
                        POST: true,
                        reload: !!carregando
                    },
                },
                htmlFooter: () => footerTotals(),

            },
            {
                label: "Salvar",
                width: "5%",
                type: "button-icon",
                css: "button",
                icon: (<SaveIcon />),
                color: (parcela) => parcela.alterada ? 'orange' : 'green',
                onClick: (parcela) => atualizarParcela(parcela)
            }
        ]
    };

    return (
        <div className="form-container">

            <div id="notification-container" className='notification-container' style={{
                position: "fixed",
                display: "flex,",
                flexDirection: "column-reverse",
                justifyContent: "flex-end",
                flexWrap: "wrap-reverse",
                alignItems: "flex-end",
                bottom: "0,",
                right: "30px",
                maxHeight: "100vh"
            }}></div>

            <Table params={tableParams} dataArray={dataArray} pageData={pageData} />
        </div>
    );
}

export default DespesaParcelaTab;
